const setupDetailsSummary = (summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    const detailsElement = event.currentTarget.closest('details');
    event.currentTarget.setAttribute('aria-expanded', !detailsElement.hasAttribute('open'));

    // only one [data-type="accordion"] is open at one time
    if (detailsElement.getAttribute('data-type') === 'accordion') {
      const siblingDetailsElements = Array.from(detailsElement.parentElement.querySelectorAll('details')).filter(
        (el) => el.id !== detailsElement.id,
      );
      siblingDetailsElements.forEach((el) => {
        el.removeAttribute('open');
        el.querySelector('summary').setAttribute('aria-expanded', false);
      });
    }

    if (detailsElement.getAttribute('data-window-class')) {
      const windowClass = detailsElement.getAttribute('data-window-class');
      if (detailsElement.hasAttribute('open')) {
        document.body.classList.remove(windowClass);
      } else {
        document.body.classList.add(windowClass);
      }
    }
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
};

window.addDetailsListeners = (container) => {
  container?.querySelectorAll('[id^="Details-"] summary').forEach(setupDetailsSummary);
};

document.querySelectorAll('[id^="Details-"] summary').forEach(setupDetailsSummary);
